import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

export default function AdminRoute({ children }) {
  const { token, loading, user } = useContext(AuthContext);
  const location = useLocation();
  const isAdmin = Array.isArray(user?.roles) && user.roles.includes('admin');

  if (loading) return <div style={{ padding: 24 }}>Loading...</div>;
  const isAuthed = Boolean(token) || Boolean(user && user._id);
  if (!isAuthed) return <Navigate to="/login" replace state={{ from: location }} />;
  if (!isAdmin) {
    return (
      <div style={{ padding: 24 }}>
        <h2 style={{ color: '#fca5a5' }}>403 Forbidden</h2>
        <p style={{ color: '#9ca3af' }}>You need admin access to view this page.</p>
      </div>
    );
  }
  return children;
}
